var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-page"},[_c('ChatContainer',{attrs:{"conversationId":_vm.conversationId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }